module.exports = __webpack_public_path__ + "static/media/manufacturing-process.e52512ae.jpeg";